import React from 'react';

import { IconBaseProps } from 'src/ui-models/Icon';
import IconBase from '../icon-base/IconBase';

const TrackerHypertensionIcon: React.FC<IconBaseProps> = ({ width = 24, height = 24, color = 'currentColor' }) => {
  return (
    <IconBase color={color} width={width} height={height}>
      <path d="M13.5213 19.0996H6.47949V20.6645H13.5213V19.0996Z" fill={color} stroke={color} />
      <path
        d="M10 19.3145C14.9706 19.3145 19 15.285 19 10.3145C19 5.34389 14.9706 1.31445 10 1.31445C5.02944 1.31445 1 5.34389 1 10.3145C1 15.285 5.02944 19.3145 10 19.3145Z"
        fill={color}
        stroke="white"
        strokeWidth="1.5"
      />
      <path d="M10 1.90137V3.21802" stroke="white" strokeLinecap="round" />
      <path d="M18.2129 9.84961H16.8948" stroke="white" strokeLinecap="round" />
      <path d="M3.08887 9.83594H1.7708" stroke="white" strokeLinecap="round" />
      <path d="M16.3018 4.96387L15.1615 5.62219" stroke="white" strokeLinecap="round" />
      <path d="M4.55664 5.93066L3.62563 4.99965" stroke="white" strokeLinecap="round" />
      <path
        d="M10.0004 11.6092C10.7152 11.6092 11.2947 11.0297 11.2947 10.3148C11.2947 9.6 10.7152 9.02051 10.0004 9.02051C9.28555 9.02051 8.70605 9.6 8.70605 10.3148C8.70605 11.0297 9.28555 11.6092 10.0004 11.6092Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.97399 9.5231L7.66419 5.3797C7.61033 5.2093 7.7048 5.0275 7.87519 4.97363C8.02713 4.9256 8.19143 4.99534 8.26242 5.138L10.1985 9.02838"
        fill="white"
      />
      <path d="M11.4881 20.6299H8.3584V23.7596H11.4881V20.6299Z" fill={color} />
    </IconBase>
  );
};

export default TrackerHypertensionIcon;
